// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__B3j4F","spinner":"loader_spinner__7sfco","spin":"loader_spin__3vAiy"};